
      if (import.meta.env.PROD && 'serviceWorker' in navigator) {
        const registerServiceWorker = () => {
          navigator.serviceWorker
            .register('/service-worker.js')
            .then((registration) => {
              console.log('ServiceWorker registered:', registration.scope);
            })
            .catch((error) => {
              console.log('ServiceWorker registration failed:', error);
            });
        };

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
          registerServiceWorker();
        } else {
          document.addEventListener('DOMContentLoaded', registerServiceWorker);
        }
      }
    